import { PublicationThumbnailFragment } from '@sketch/gql-types'

interface PublicationThumbnailSource {
  standard: string | undefined
  retina: string | undefined
}

const THUMBNAIL_TYPE_LARGE = 'L'

export type PublicationThumbnail = PublicationThumbnailSource | undefined

export const getPublicationThumbnail = (
  previewFile?: PublicationThumbnailFragment['previewFile'] | null
): PublicationThumbnail => {
  if (!previewFile?.thumbnails?.length) {
    return
  }

  const { thumbnails } = previewFile

  const profileThumbnail = thumbnails.find(
    thumbnail => thumbnail?.type === THUMBNAIL_TYPE_LARGE
  )

  const sources = {
    retina: profileThumbnail?.url2x?.toString(),
    standard: profileThumbnail?.url?.toString(),
  }

  const hasUrls = !!Object.values(sources).find(value => !!value)

  if (!hasUrls) {
    return undefined
  }

  return sources
}
